export const PREVIEW_COOKIE_KEY = '__frankli-preview__';

export const STORYBLOK_PAGES_PREFIX = 'pages/';

export const STORYBLOK_SPACE_ID = '277563';

export const HUBSPOT_API_REGION = 'na1';
export const HUBSPOT_API_PORTAL_ID = '7552255';

export const VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogg'];
